import riskApi from '@Apis/risks.api';
import { RiskTemplateCatalogEntry } from '@Types/riskTemplateCatalog.types';
import { AxiosResponse } from 'axios';

export const getRiskTemplateCatalogApi = (
	systemTypeId: string,
	assetTypeId: string,
): Promise<AxiosResponse<RiskTemplateCatalogEntry[]>> => {
	return riskApi.get<RiskTemplateCatalogEntry[]>('/risk/template/catalog', {
		params: { systemTypeId, assetTypeId },
	});
};
